import type { GetDialogAudienceRequest, GetDialogBroadcastsRequest, GetDialogBroadcastDialogsRequest } from '../model/types';
import { getDialogBroadcastsApi, getDialogTemplatesApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type {
    DialogTemplateResponse,
    DialogBroadcastListResponse,
    DialogAudienceResponse,
    DialogBroadcastDetailsResponse,
    PublishDialogBroadcastRequest,
    SaveDialogTemplateRequest,
} from '@/core/generated/api';

/** Выполняет операции с конфигурациями и выпусками диалогов */
export const dialogService = {
    /** Загружает шаблоны */
    async getTemplates(): Promise<DialogTemplateResponse[]> {
        try { return (await getDialogTemplatesApi().apiV1DialogsTemplatesGet({})).data; }
        catch (error: unknown) { return rethrowHandledApiError(error); }
    },

    /** Сохраняет шаблон */
    async saveTemplate(request: SaveDialogTemplateRequest, id?: string): Promise<string> {
        try {
            if (id) {
                await getDialogTemplatesApi()
                    .apiV1DialogsTemplatesTemplateIdPut({
                        templateId: id,
                        saveDialogTemplateRequest: request
                    });

                return id;
            }
            return (await getDialogTemplatesApi().apiV1DialogsTemplatesPost({ saveDialogTemplateRequest: request })).data;
        } catch (error: unknown) { return rethrowHandledApiError(error); }
    },

    /** Загружает выпуски */
    async getBroadcasts(request: GetDialogBroadcastsRequest): Promise<DialogBroadcastListResponse> {
        try { return (await getDialogBroadcastsApi().apiV1DialogsBroadcastsGet(request)).data; }
        catch (error: unknown) { return rethrowHandledApiError(error); }
    },

    /** Загружает получателей */
    async getAudience(request: GetDialogAudienceRequest): Promise<DialogAudienceResponse> {
        try { return (await getDialogBroadcastsApi().apiV1DialogsBroadcastsAudienceGet(request)).data; }
        catch (error: unknown) { return rethrowHandledApiError(error); }
    },

    /** Выпускает диалоги */
    async publish(request: PublishDialogBroadcastRequest): Promise<string> {
        try { return (await getDialogBroadcastsApi().apiV1DialogsBroadcastsPost({ publishDialogBroadcastRequest: request })).data; }
        catch (error: unknown) { return rethrowHandledApiError(error); }
    },

    /** Загружает статистику и назначения */
    async getDetails(
        id: string,
        request: GetDialogBroadcastDialogsRequest
    ): Promise<DialogBroadcastDetailsResponse> {
        try {
            return (await getDialogBroadcastsApi()
                .apiV1DialogsBroadcastsBroadcastIdGet({
                    broadcastId: id,
                    ...request
                })).data;
        }
        catch (error: unknown) { return rethrowHandledApiError(error); }
    },
};
